import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import HeaderLinksQuickEditOverlayClass from './HeaderLinksQuickEditOverlayClass';
import { getRectPositionCheckingBounds } from 'dom-utils';
import useFloatMenu from 'hooks/use-float-menu';
import { setNavigationSelectedInTheDropdown } from 'services/navigationv2';

const HeaderLinksQuickEditOverlay = (props) => {
  const setMenuPosition = useCallback((menu: HTMLDivElement, menuContainer: HTMLDivElement) => {
    const menuContainerRect = menuContainer.getBoundingClientRect();
    const safePosition = getRectPositionCheckingBounds({
      elem: menu,
      position: {
        x: menuContainerRect.left,
        y: menuContainerRect.bottom,
      },
    });

    menu.style.left = `0px`;
    menu.style.top = `${safePosition.y - 46}px`;
  }, []);
  const { isOpen: isFloatMenuOpen, containerRef, positionMenu, toggleMenu } = useFloatMenu(setMenuPosition);
  const dispatch = useDispatch();

  return (
    <HeaderLinksQuickEditOverlayClass
      {...props}
      isFloatMenuOpen={isFloatMenuOpen}
      containerRef={containerRef}
      positionMenu={positionMenu}
      toggleMenu={toggleMenu}
      dispatch={dispatch}
    />
  );
};

export default HeaderLinksQuickEditOverlay;
